import MaterialIcons from '@expo/vector-icons/MaterialIcons';

import { IRestaurant } from '@rbi-ctg/store';
import { OrderEtaContainer, OrderEtaDescription } from 'components/sanity-store-order-eta/styled';
import { useRoute } from 'hooks/navigation/use-route';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { routes } from 'utils/routing';

export const StoreSanityOrderEta = ({ store }: { store: IRestaurant }) => {
  const isMobileBreakpoint = useIsMobileBreakpoint();
  const { pathname } = useRoute();

  if (!store.isOrderEtaEnabled || !store.orderEtaValue) {
    return null;
  }

  return (
    <OrderEtaContainer ml={!isMobileBreakpoint && pathname !== routes.cart ? '$4' : undefined}>
      <MaterialIcons name="access-time-filled" size={16} color={primitive.$bbqBrown} />
      <OrderEtaDescription>{`${store.orderEtaValue} ${t('eta')}`}</OrderEtaDescription>
    </OrderEtaContainer>
  );
};
